import { gql, useQuery } from '@apollo/client';
import {
  GetArchivesQuery,
  GetArchivesQueryVariables,
} from '__generated__/queries-photo';
import { ARCHIVE_FRAGMENT } from 'apollo/fragments/archive.photo.graphql';

export const GET_ARCHIVES = gql`
  query GetArchives(
    $where: ArchiveWhereInput
    $first: Int!
    $orderBy: [ArchiveOrderByInput!]
    $skip: Int
  ) {
    archives(where: $where, first: $first, orderBy: $orderBy, skip: $skip) {
      ...Archive
    }
  }
  ${ARCHIVE_FRAGMENT}
`;

export const useGetArchives = (variables: GetArchivesQueryVariables) => {
  return useQuery<GetArchivesQuery, GetArchivesQueryVariables>(GET_ARCHIVES, {
    variables,
    fetchPolicy: 'cache-and-network',
  });
};
